export default {
    textarea: {
        margin: '0px',
        width: '200px',
        height: '72px'
    }
}